import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";
import UserDropdown from "./UserDropdown";

export default function UserMenu({
  isLoggedIn,
  user,
  setUser,
  setShowModal,
}) {
  const [userOpen, setUserOpen] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    if (isLoggedIn) {
      navigate("/profile");
    } else {
      setShowModal(true);
    }
  };

  return (
    <div
      className="relative flex flex-col items-center"
      onMouseEnter={() => {
        if (isLoggedIn) {
          setUserOpen(true);
        }
      }}
      onMouseLeave={() => setUserOpen(false)}
    >
      {/* =========================
          USER BUTTON
      ========================= */}

      <button
        aria-label="User account"
        onClick={handleClick}
        className="
          text-[#3B2A1F]
          hover:text-[#0F766E]
          transition
        "
      >
        {isLoggedIn ? (
          <span
            className="
              w-8
              h-8
              bg-[#0F766E]
              hover:bg-[#115E59]
              flex
              items-center
              justify-center
              rounded-full
              font-semibold
              text-sm
              text-white
              shadow-md
              transition-all
              duration-200
            "
          >
            {user?.first_name?.[0]?.toUpperCase()}
            {user?.last_name?.[0]?.toUpperCase()}
          </span>
        ) : (
          <FaRegUser />
        )}
      </button>

      {/* =========================
          USER DROPDOWN
      ========================= */}

      {userOpen && (
        <UserDropdown
          isLoggedIn={isLoggedIn}
          user={user}
          setUser={setUser}
          closeMenu={() => setUserOpen(false)}
          openModal={() => setShowModal(true)}
        />
      )}
    </div>
  );
}